import * as types from './types'
// setPreviewInfo
export const setPreviewInfo = ({ commit }, data) => {
  commit(types.SET_PREVIEW_INFO, data)
}
